/**
 * Commission documents store `commissionRate` as a 0–100 number (e.g. 6 for 6%).
 * Affiliate profile APIs may return a decimal (e.g. 0.07 for 7%). Normalize for display.
 */
export function formatCommissionPercentForDisplay(
  rate: number | undefined | null
): string {
  if (rate == null || Number.isNaN(Number(rate))) {
    return '—';
  }
  const n = Number(rate);
  // Stored as 1–100 (e.g. 6 = 6%, 1 = 1%). Use >= 1 so 1% does not multiply as decimal.
  if (n >= 1 && n <= 100) {
    return `${n.toFixed(1)}%`;
  }
  return `${(n * 100).toFixed(1)}%`;
}
